<template>

  <div class="main">
    <header>
      <div class="text" style="float: left;">
        <h2 >资料上传</h2>
      </div>
      <div style="  clear:both;"></div>
      <div class="tag">
        <el-tag
          v-for="item in quarters"
          :key="item.id"
          :type="item.name"
          :class="{active : item.id===aquarter}"
          @click="setbat(item.id)"
          effect="light">
          {{ item.name }}
        </el-tag>
      </div>
      <div class="data">
        <el-date-picker
          v-model="ayears"
          type="year"
          format="yyyy"
          value-format="yyyy"
          @change="pickerChangeFn"
          placeholder="请选择年份">
        </el-date-picker>

        <div class="uarter">

          <el-button
            size="small"
            type="success"
            slot="trigger"
            @click="openuploads()"
            >上传文件</el-button>
          <el-button
            size="small"
            slot="trigger"
            @click="drawer = true;"
          >上传进度</el-button>

        </div>
      </div>

      <div style="clear:both;"></div>
    </header>

    <div class="table-box">

      <ul>
        <h3 v-if="ScoreFileList.length ==0" style="font-size: 18px">暂无考核资料，请上传相关文件</h3>
        <li v-for="(item,index) in ScoreFileList" :key="index">
         <p>{{item.scoreItemName}}（分值：{{item.scoreValue}}分）</p>
          <div class="upload"
            style="border: 0px dashed #d9d9d9; float: none;width: 100% ; height: 0.5rem">
          </div>
            <div class="list">
              <dl>
                <dd v-for="items in item.fileJson" >
                  <el-link  type="primary" :href="items.url" target="_blank">
                   <img class="icon" v-if="fileset(items.fileName) == 'doc' " src="../assets/images/doc.png"/>
                    <img class="icon" v-else-if="fileset(items.fileName) == 'docx'" src="../assets/images/doc.png"/>
                    <img class="icon" v-else-if="fileset(items.fileName) == 'pdf' " src="../assets/images/pdf.png"/>
                    <img class="icon" v-else-if="fileset(items.fileName) == 'xls'" src="../assets/images/xls.png"/>
                    <img class="icon" v-else-if="fileset(items.fileName) == 'xlsx'" src="../assets/images/xls.png"/>
                    <img class="icon" v-else src="../assets/images/doc.png"/>
                    <div class="name">
                    <h3>{{items.fileName}}</h3>
                    <div class="close"></div>
                  </div>
                  </el-link>
                </dd>
              </dl>
              <div style="clear:both;"></div>
            </div>
        </li>


        </ul>

    </div>
    <el-dialog  :visible.sync="openupload"  width="40%"  :before-close="uploadclose">
      <el-form ref="form"  label-width="150px" style="padding:0 30px ">
      <el-form-item label="年份:">
        <el-date-picker
          v-model="uploadf.ayears"
          size="small"
          type="year"
          format="yyyy"
          value-format="yyyy"
          @change="pickerChangeFn"
          placeholder="请选择年份">
        </el-date-picker>

      </el-form-item>
        <el-form-item label="季度:">
              <el-select v-model="uploadf.aquarter" placeholder="请选择季度"    size="small" :clearable ="true">

                <el-option

                  v-for="item in quarters"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
        </el-form-item>
      <el-form-item label="指标项:">
        <el-radio-group v-model="uploadf.scoreItem" size="mini">
          <el-radio v-for="(item,index) in ScoreItemAll" :key="index" :label="item.id" border>{{item.scoreItem}}</el-radio>

        </el-radio-group>
      </el-form-item>
      <el-form-item label="上传文件:">
        <el-upload
          class="upload-demo"

          action="#"
          ref="fileupload"
          :on-change="handlechange"
          :on-remove="handleRemove"
          :multiple="true"
          :limit="10"
          name="files"
          :on-exceed="handleExceed"
          :auto-upload="false"
      >
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>

          <div slot="tip" class="el-upload__tip">只能上传doc/pdf/docx/xlsx文件</div>
        </el-upload>
     </el-form-item>


      <el-form-item style="float: right">
        <el-button type="primary" size="small" @click="UploadProgress()">确认提交</el-button>

      </el-form-item>
        <div style="  clear:both;"></div>
    </el-form>
    </el-dialog>

    <el-drawer
      :visible.sync="drawer"
      direction="btt"
      title="上传进度"
      size="35%"
      :close-on-press-escape =false
     >
      <div class="list drawer__conten">
        <h3 v-if="progresslist.length ==0" style="font-size: 18px">暂无考核资料，请上传相关文件</h3>
        <dl>

          <dd  v-for="(item,index) in progresslist" :key="index">
            <el-link  type="primary" target="_blank">
              <img class="icon" v-if="fileset(item.fileName)== 'doc'" src="../assets/images/doc.png"/>
              <img class="icon" v-else-if="fileset(item.fileName)== 'docx'" src="../assets/images/doc.png"/>
              <img class="icon" v-else-if="fileset(item.fileName) == 'pdf' " src="../assets/images/pdf.png"/>
              <img class="icon" v-else-if="fileset(item.fileName) == 'xls'" src="../assets/images/xls.png"/>
              <img class="icon" v-else-if="fileset(item.fileName) == 'xlsx'" src="../assets/images/xls.png"/>
              <img class="icon" v-else src="../assets/images/doc.png"/>
              <div class="name">

                <h3>{{item.fileName}}</h3>
                <el-progress :percentage="item.progress" color="#109585"></el-progress>

                <div class="close"></div>
              </div>
            </el-link>
          </dd>



        </dl>
        <div style="clear:both;"></div>
      </div>

    </el-drawer>
  </div>

</template>

<script>

export default {
  name: "Operaview",
  data(){
    return{
      quarters: [
        {   id:1,
          name: '第一季度',

        },
        {   id:2,
          name: '第二季度',

        },
        {
          id:3,
          name: '第三季度',
        },
        {
          id:4,
          name: '第四季度',
        },
      ],
      aquarter:'',
      ScoreTypelist:[],
      scoreType:'',
      ayears:'',
      ScoreFileList:[],
      openupload:false,
      ScoreItemAll:[],
      ScoreFileListupload:[],
      uploadFileNo:'',
      uploadf:{
        ayears:'',
        aquarter:'',
        scoreItem:'',

      },
      fileMap:[],
      drawer:false,
      dosgo:false,
      timer:[],
      progresslist:[],
      ScoreFileListsess:[],
    }
  },
  props:["curId"],

  watch:{
    curId:function (value){
      this.selectScoreFileList();

    },
    ayears:function (value){
      this.selectScoreFileList();
    },
    scoreType:function (value){
      this.selectScoreFileList();
    },

  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{
      // vm.getGradeDet();
    });
  },
  mounted () {

    this.getScoreTypeList();
    window.setTimeout(() => {
      this.selectScoreFileList();
    }, 200);
  },
  methods: {
    pickerChangeFn(value){ // 日期选择器改变事件 ~ 解决日期选择器清空 值不清空的问题
      if(value===null){
        this.ayears = value
        this.uploadf.ayears = value
      }},
    setbat(index) {
      this.aquarter = index;
      this.selectScoreFileList();

    },
    getScoreTypeList() {
      let that = this;
      that.$axios
        .get('/webapi/scoreType/getScoreTypeList')
        .then(function (res) {
          that.ScoreTypelist = res.data.data;
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误" + error);
      });
    },
    selectScoreFileList() {
      this.ScoreFileList = [];
      let that = this;
      let myDate = new Date();
      let years = myDate.getFullYear(); //获取当前年
      this.ayears = this.ayears || '' + years;
      let mon = myDate.getMonth() + 1; //获取当前月
      let aquarters = 1
      if (mon >= 1 && mon < 4) {
        aquarters = 1;
      } else if (mon >= 4 && mon < 7) {
        aquarters = 2;
      } else if (mon >= 7 && mon < 10) {
        aquarters = 3;
      } else if (mon >= 10 && mon < 12) {
        aquarters = 4;
      }
      this.aquarter = this.aquarter || aquarters;
      let ScoreFiledata = {
        operatorNum: this.curId,
        year: this.ayears,
        quarter: this.aquarter,
        scoreTypeId: this.scoreType
      }
      that.$axios
        .post('/webapi/scoreItemFile/selectScoreFileList', ScoreFiledata)
        .then(function (res) {

          if (res.data.code == 200) {

              that.ScoreFileList=res.data.data



            //console.log(that.ScoreFileList)

          } else {
            that.$message.error(res.data.msg)
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误" + error);
      });


    },

    fileset(data) {
      let filedians = data.replace(/.+\./, "");
      return filedians;

    },
    uploadclose() {
      this.openupload = false;
      this.uploadf={
           ayears:'',
          aquarter:'',
          scoreItem:'',
      }
      this.$refs['fileupload'].clearFiles();
    },
    openuploads() {
      this.selectScoreItemAll();
      this.openupload = true;
    },
    selectScoreItemAll() {
      let that = this;
      that.$axios
        .get('/webapi/scoreItem/selectScoreItemAll')
        .then(function (res) {
          if (res.data.code == 200) {
            that.ScoreItemAll = res.data.data;
          } else {
            that.$message.error(res.data.msg)
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误" + error);
      });

    },
    handlechange(file, fileList) {

      this.ScoreFileListupload = fileList;
    },
    handleRemove(file, fileList) {
      this.ScoreFileListupload = fileList;
    },
    handleExceed(file, fileList){

      this.$message.warning(`上传文件数量不能超过10个，请从新上传！！！`);

    },
    getUploadFileNo() {
      var that = this;
      that.$axios
        .get("/webapi/upload/getUploadFileNo")
        .then(function (res) {
          if (res.data.code == 200) {
            that.uploadFileNo = res.data.data;

          }
          else {

            that.$message.error(
              res.data.msg
            );
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }
        })
    },


    UploadProgress() {
      if (this.uploadf.ayears == ''|| this.uploadf.ayears == null) {
        this.$message.error("请选择年份");
        return false;
      }
      if (this.uploadf.aquarter == '') {
        this.$message.error("请选择季度");
        return false;
      }
      if (this.uploadf.scoreItem == '') {
        this.$message.error("请选择指标项");
        return false;
      }
      if (this.ScoreFileListupload.length == 0) {
        this.$message.error("请上传文件");
        return false;
      }
      for (let i = 0; i < this.ScoreFileListupload.length; i++) {
        this.beforeFileUpload(this.ScoreFileListupload[i])
      }
      if (this.dosgo == true) {
        this.openupload = false;


        this.selectPicUpload();
        this.drawer = true;


          this.timer=window.setInterval(() => {
            if(this.progresslist.length > 0) {
              for (let i = 0; i < this.progresslist.length; i++) {
                let files = this.progresslist[i];
                this.getUploadProgress(files.uploadFileNo);
              }
            }
          }, 1000);

      }


    },
    beforeFileUpload(file) {
      let fileName = file.name;

      let pos = fileName.lastIndexOf(".");
      let lastName = fileName.substring(pos, fileName.length);
      if (
        lastName.toLowerCase() !== ".pdf" &&
        lastName.toLowerCase() !== ".doc" &&
        lastName.toLowerCase() !== ".docx" &&
        lastName.toLowerCase() !== ".xls" &&
        lastName.toLowerCase() !== ".xlsx"
      ) {
        this.$message.error("文件必须为.pdf .doc .docx .xls .xlsx类型");
        this.dosgo = false;
      } else {
        this.dosgo = true;
      }
    },
    // handleClose(done) {
    //   this.$confirm('确认关闭？')
    //     .then(_ => {
    //       done();
    //     })
    //     .catch(_ => {
    //     });
    // },
    getUploadProgress(uploadFileNo) {
      let that = this;
      let uploadFileNodeta = {
        uploadFileNo: uploadFileNo
      }
      that.$axios
        .post('/webapi/upload/getUploadProgress', uploadFileNodeta)
        .then(function (res) {

          if (res.data.code == 200) {

            for(let i=0;i< that.progresslist.length;i++){

              let file = that.progresslist[i];
              if(res.data.data.uploadFileNo == file.uploadFileNo){
                if(that.progresslist[i].progress < res.data.data.progress){
                  that.progresslist[i].progress = Number(res.data.data.progress);
                }
              }
              //console.log(res.data.data.progress)
              if(res.data.data.progress == 100){
                that.progresslist.splice(that.progresslist[i],1);
              }
              if(that.progresslist.length == 0){
                window.clearInterval(that.timer)
              }

            }

          }else {
            that.$message.error(
              res.data.msg
            );
//          window.setTimeout(() => {
//            location.reload();
//          }, 1000);
          }
          // console.log(res);
        }).catch(function (error) { // 请求失败处理
          console.log("服务器错误" + error);
        });
    },

    selectPicUpload() {
      let that = this;
      let fileMaplit = [];

      let fd = new FormData(); //参数的格式是formData格式的
      for (let i = 0; i < that.ScoreFileListupload.length; i++) {
        that.$axios
          .get("/webapi/upload/getUploadFileNo")
          .then(function (res) {

            if (res.data.code == 200) {

              let uploadFileNo = res.data.data;
              const fileMaps = {fileName: that.ScoreFileListupload[i].name, uploadFileNo: uploadFileNo};

              fileMaplit.push(fileMaps);
              fd.append("files", that.ScoreFileListupload[i].raw);

              let fileMaplist = {
                fileName: that.ScoreFileListupload[i].name,
                uploadFileNo: uploadFileNo,
                progress: 0
              };
              that.progresslist.push(fileMaplist);
              //console.log(that.progresslist)
            }else {

                that.$message.error(
                  res.data.msg
                );
                window.setTimeout(() => {
                  location.reload();
                }, 1000);
            }

          }).catch(function (error) { // 请求失败处理
            console.log("服务器错误" + error);
            return false
        });
      }

      window.setTimeout(() => {
        let filemapa = JSON.stringify(fileMaplit);
        console.log(111)
        let fileJson =[];
        let operator={
          scoreItemId:that.uploadf.scoreItem,
          year:that.uploadf.ayears ,
          quarter:that.uploadf.aquarter,
        }
        //参数
        fd.append("fileMap", filemapa);
        console.log(222)
        that.$axios.post("/webapi/upload/uploadDocs", fd)
          .then((res) => {

            console.log(333)
            if(res.data.code == 200){

              for (let i=0; i<res.data.data.length; i++){
                let files = {fileName: res.data.data[i].fileName, url: res.data.data[i].url};
                fileJson.push(files);

              }
              let fileJsona = JSON.stringify(fileJson);

              let uploadScoreFiledata={
                operatorNum:that.curId,
                fileJson:fileJsona
              }
              let uploadScoreFile =Object.assign(operator , uploadScoreFiledata)
              that.$axios.post("/webapi/scoreItemFile/uploadScoreFile", uploadScoreFile)
                .then((res) => {

                  if(res.data.code ==200){
                    that.$message.success({
                      message: '上传成功',
                    });
                    that.drawer = false;
                  } else {

                that.$message.success(
                  res.data.msg
                );
                window.setTimeout(() => {
                  location.reload();
                }, 1000);
              }

                }).catch(function (error) { // 请求失败处理
                console.log("服务器错误" + error);
              });
            }else {

              that.$message.error(
                res.data.msg
              );
              window.setTimeout(() => {
                location.reload();
              }, 1000);
            }


        }).catch(function (error) { // 请求失败处理
          console.log("服务器错误" + error);
          return false;
        });

      }, 1000);

    },
  }

}
</script>
<style scoped>
/deep/ .el-link--inner{display: flex}
/deep/ .el-form-item__content{text-align: left}
/deep/ .el-form-item__label{
  height: 20px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}
/deep/ .el-drawer__header {height: 30px}
/deep/ .el-drawer__header span{font-size: 24px;color: #222222; line-height: 20px;margin-left: 250px; text-align: left}

.el-upload__tip{
  line-height:1;
  margin-bottom: 0px;
}
.el-upload {
  border: 0px dashed #d9d9d9;
  border-radius: 0%;
  float: left;
}
.el-radio{margin-right: 0px;margin-left: 0px!important;
  line-height: 1;
}
.tag .el-tag{
  height: 40px;
  width: 113px;
  line-height: 40px;
  color: #484848;
  background: #ffffff;
  border: 0px;
  cursor: pointer;
}
.tag .el-tag:hover,.tag .el-tag.active{
  color: #ffffff;
  background: #109585;

}
.data{
  float: right;
  line-height: 0;
  margin-top: -50px;
  text-align: right;
}
.uarter{
  margin-top: 10px;
  line-height: 0;
}
.tag{float: left;
  line-height: 0;
}
.table-box {
  margin-top: 30px;
  padding:60px;
  background: #FFFFFF;
}
.table-box ul{
  margin: 0;
  padding: 0;
}
.table-box ul li:first-child{
  margin-top: 0;
}
.table-box ul li{
  width: 100%;
  list-style:none;
  margin-top: 60px;
  padding-bottom: 30px;
  border-bottom: 1px solid #e2e2e2;
}
.table-box ul li p{
  font-size: 0.22rem;
  font-family: PingFang SC;
  font-weight: normal;
  color: #282828;
  line-height: 0;
  float: left;
  margin: 0;
}
.table-box ul li .upload{
  line-height: 0;
  float: right;
  margin: 0;
  text-align: right;
}
.el-button--success{
  background: rgba(16, 149, 133, 0.1000);
  color: #109585;
  border: 0px;
  width: 1.5rem;
  height: 40px;
}
.el-button--default{
  background:  #109585;
  color: #ffffff;
  border: 0px;
  width: 1.5rem;
  height: 40px;
}
.table-box ul li dl{
   margin: 20px;

}
.table-box ul li dl dd img{
  width: 0.8rem;
  width: 0.8rem;
}
.table-box ul li dl dd{
    float: left;
    margin: 10px;

   display: flex;
}
.table-box ul li dl dd a span{
  display: flex;
}
.table-box ul li dl dd .name h3{
 font-size: 0.18rem;
  margin: 13px;
  margin-bottom: 10px;
  color: #484848;

}
.table-box ul li dl dd .name .el-progress{
  line-height: 0;
  margin-left: 13px;
}

.drawer__conten dl{text-align: left; margin-left: 250px;margin-top: 0px}

.drawer__conten dl dd{line-height: 0}
.drawer__conten dl dd img{width: 50px;height: 51px}
.drawer__conten dl dd .name{width: 15rem;padding: 10px}
.drawer__conten dl dd .name h3{line-height: 0;
  margin: 10px;
  margin-top: 10px;
  font-size: 0.18rem;
  margin: 13px;
  margin-bottom: 10px;
  margin-left: 0px;
  color: #484848;}
.drawer__conten dl dd a:hover:after{
  border: 0px;
}
</style>



// WEBPACK FOOTER //
// src/view/Upload.vue